export default "__VITE_ASSET__BnPHiOss__"